import { Input } from "@/components/ui/input";
import { Field, TextField, ChoiceCard } from "./Fields";
import { STYLES } from "@/lib/constants";

function ColorInput({ value, onChange, testId }) {
  return (
    <div className="flex gap-2">
      <input type="color" value={value || "#0F172A"} onChange={(e) => onChange(e.target.value)} className="h-10 w-12 rounded-md border bg-white p-1 cursor-pointer" data-testid={`${testId}-picker`} />
      <Input value={value} onChange={(e) => onChange(e.target.value)} placeholder="Nessuna preferenza" className="bg-white font-mono text-sm" data-testid={testId} />
    </div>
  );
}

export default function StepVisual({ form, set }) {
  const v = form.visual;
  const setV = (patch) => set({ visual: { ...v, ...patch } });
  const toggleStyle = (s) => setV({ styles: v.styles.includes(s) ? v.styles.filter((x) => x !== s) : [...v.styles, s] });
  return (
    <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
      <Field label="Colore principale"><ColorInput value={v.primary_color} onChange={(c) => setV({ primary_color: c })} testId="visual-primary-input" /></Field>
      <TextField label="Colori secondari" value={v.secondary_colors} onChange={(c) => setV({ secondary_colors: c })} placeholder="Es. beige sabbia, verde salvia" testId="visual-secondary-input" />
      <TextField label="Font" value={v.font} onChange={(c) => setV({ font: c })} placeholder="Es. serif elegante per i titoli" testId="visual-font-input" />
      <Field label="Tema">
        <div className="grid grid-cols-3 gap-2">
          {[["", "Libero"], ["chiaro", "Chiaro"], ["scuro", "Scuro"]].map(([k, l]) => (
            <ChoiceCard key={k || "auto"} title={l} active={v.theme === k} onClick={() => setV({ theme: k })} testId={`visual-theme-${k || "auto"}`} />
          ))}
        </div>
      </Field>
      <Field label="Stile generale (anche più di uno)" className="md:col-span-2">
        <div className="flex flex-wrap gap-2">
          {STYLES.map((s) => (
            <button key={s} type="button" onClick={() => toggleStyle(s)} data-testid={`style-chip-${s.toLowerCase()}`}
              className={`px-3.5 py-1.5 rounded-full text-xs border transition-colors ${v.styles.includes(s) ? "bg-navy-900 text-white border-navy-900" : "bg-white text-slate-600 border-slate-200 hover:border-slate-400"}`}>{s}</button>
          ))}
        </div>
      </Field>
      <TextField className="md:col-span-2" multiline label="Riferimenti visivi (solo ispirazione per l'IA, non pubblicati)" value={v.references} onChange={(c) => setV({ references: c })} placeholder="Link a siti di riferimento, mood, dettagli che ti piacciono" testId="visual-references-input" />
      <TextField className="md:col-span-2" multiline label="Indicazioni aggiuntive" value={v.notes} onChange={(c) => setV({ notes: c })} testId="visual-notes-input" />
    </div>
  );
}
